import { RequestCandidateEntityLevel, RequestEntityStatus } from "generated";

export const RequestStatusSelect = [
  {
    value: RequestEntityStatus.Done,
    label: "Done",
  },
  {
    value: RequestEntityStatus.InProgress,
    label: "In Progress",
  },
  {
    value: RequestEntityStatus.New,
    label: "New",
  },
  {
    value: RequestEntityStatus.Draft,
    label: "Draft",
  },
  {
    value: RequestEntityStatus.WaitingForApproval,
    label: "Waiting For Approval",
  },
  {
    value: RequestEntityStatus.Rejected,
    label: "Rejected",
  },
];

export const RequestStatusSearchSelect = [
  ...RequestStatusSelect,
  {
    value: "All",
    label: "All",
  },
];

export const RequestCandidateLevelSelect = [
  {
    value: RequestCandidateEntityLevel.Assistant,
    label: "Assistant",
  },
  {
    value: RequestCandidateEntityLevel.AssociateDirector,
    label: "AssociateDirector",
  },
  {
    value: RequestCandidateEntityLevel.AssociateManager,
    label: "AssociateManager",
  },
  {
    value: RequestCandidateEntityLevel.AssociatePrincipal,
    label: "AssociatePrincipal",
  },
  {
    value: RequestCandidateEntityLevel.CEO,
    label: "CEO",
  },
  {
    value: RequestCandidateEntityLevel.Consultant,
    label: "Consultant",
  },
  {
    value: RequestCandidateEntityLevel.DeputyCEO,
    label: "DeputyCEO",
  },
  {
    value: RequestCandidateEntityLevel.Director,
    label: "Director",
  },
  {
    value: RequestCandidateEntityLevel.Intern,
    label: "Intern",
  },
  {
    value: RequestCandidateEntityLevel.JuniorPrincipal,
    label: "JuniorPrincipal",
  },
  {
    value: RequestCandidateEntityLevel.Manager,
    label: "Manager",
  },
  {
    value: RequestCandidateEntityLevel.Principal,
    label: "Principal",
  },
  {
    value: RequestCandidateEntityLevel.SeniorConsultant,
    label: "SeniorConsultant",
  },
  {
    value: RequestCandidateEntityLevel.SeniorPrincipal,
    label: "SeniorPrincipal",
  },
  {
    value: RequestCandidateEntityLevel.Supervisor,
    label: "Supervisor",
  },
  {
    value: RequestCandidateEntityLevel.TTP,
    label: "TTP",
  },
  {
    value: RequestCandidateEntityLevel.Trainee,
    label: "Trainee",
  },
];
